<template>
  <div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">鼓楼医院餐厨垃圾智慧处理系统</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <div class="model">
          <div class="model_title">【企业介绍】</div>
          <div class="section">
            鼓楼医院餐厨垃圾智慧处理系统主要是针对餐厨剩余垃圾处理过程的监管和处理设备的实时管控。通过给每一台餐厨垃圾处理设备安装物联网网关盒子，通过该盒子读取设备内部的PLC数据并实时回传云平台，进行数据的治理、分析和存储，并将实时运行数据、故障信息发送给一线设备管理人员。
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div>
            <div class="section">平台运营管理</div>
            <div class="section">
              <img src="../../assets/caseDetail/tianjian.png" alt="" />
            </div>
            <div class="section">
              平台运营管理主要为设备管理者提供设备运营总体情况，分析设备利用率负荷情况等。采用地图展示设备的服务社区范围，当点击到单个设备时，右侧出现设备的运行信息和历史运行信息。
            </div>
          </div>

          <div>
            <div class="section">设备资产管理</div>
            <div class="section">
              <img src="../../assets/caseDetail/tianjian2.png" alt="" />
            </div>
            <div class="section">
              设备资产管理主要面向设备管理者，洞悉目前平台的设备具体信息。设备管理者可以实时录入设备信息，在线查看设备在线状态，也可查看设备的详细运行参数及各项报警信息.
            </div>
          </div>

          <div>
            <div class="section">APP—运行数据实时监控</div>
            <div class="section">
              <img src="../../assets/caseDetail/tianjian3.png" alt="" />
            </div>
            <div class="section">
              设备管理员可以实时查看设备运行设定参数和运行情况，根据设备报警信息进行相关预警处理.
            </div>
          </div>

          <div>
            <div class="section">设备故障一键报修</div>
            <div class="imageContainer">
              <img src="../../assets/caseDetail/tianjian4.png" alt="" />
            </div>
            <div class="section">
              设备管理员针对故障设备提交报修信息，系统统一派单，报修人员实时查看维修进度，缩短维修时长，提高维修效率.
            </div>
          </div>

          <div>
            <div class="section">售后服务管理</div>
            <div class="imageContainer">
              <img src="../../assets/caseDetail/tianjian5.png" alt="" />
              <img src="../../assets/caseDetail/tianjian6.png" alt="" />
            </div>
            <div class="section">
              可以实时处理APP端上传的用户提报的故障信息，根据订单情况，指派相应的维修人员，快速响应客户现场；也可实时查看订单当前状态，实时查看维修流程关键节点。
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            设备设计和安装的应用：通过本系统的使用完成了智能餐厨生化处理设备的智能化升级，优化了上料结构、油水分离装置等机构；缩短电气安装时间45%以上。
          </div>
          <div class="section">
            系统运维的应用:
            对餐厨垃圾处理项目的垃圾处理量、有机物产量、废油产量，破碎电机、搅拌电机和压榨电机运行状态、设备内外部温度指数，设备异常和故障诊断，以及设备负荷等实际状况进行多维度全方位的管理监控。
          </div>
          <div class="section">
            设备设计和安装的应用：通过本系统的使用完成了智能餐厨生化处理设备的智能化升级，优化了上料结构、油水分离装置等机构；缩短电气安装时间45%以上。
          </div>
          <div class="section">
            系统运维的应用:
            设备售后服务的应用：进行设备维修、维护的远程一键式填报，完善的维修流程，缩短了设备使用者的售后时间，简化了设备售后服务流程，提高了售后维修效率。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseTianjianDetail",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss">
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer{
        width: 100%;
        display: flex;
        justify-content: space-around;
        img{
          width: 242px;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseTianjianDetail.vue